export default __webpack_public_path__ + "static/eds-map-2-595e8c62087d426a2eca565b133caf92.gif";